// src/hooks/useGetFWIZones.js
import { useEffect, useState } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils';

export default function useGetFWIZones(visible = true) {
  const [zones, setZones] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    let aborted = false;

    const fetchZones = () => {
      setLoading(true);
      authFetch(`${API_URL}fwi/zones-geojson`)
        .then(res => {
          if (!res.ok) throw new Error('Error al cargar zonas FWI');
          return res.json();
        })
        .then(data => {
          if (!aborted) setZones(data);
        })
        .catch(err => {
          if (!aborted) setError(err.message);
        })
        .finally(() => {
          if (!aborted) setLoading(false);
        });
    };

    fetchZones();
    const interval = setInterval(fetchZones, 60000);

    return () => {
      aborted = true;
      clearInterval(interval);
    };
  }, [visible]);

  return { zones, error, loading };
}
